import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { IconModule } from '@hglobal/common';
import { Observable } from 'rxjs';

import { TableComponent } from '@pp/common';
import { GetPaginationRes } from '@pp/core/entities';
import { ShortNumberPipe, ToCurrencyModule } from '@pp/core/pipes';

import { ChangeType, CryptoMarketRate } from './crypto-market.entities';

@Component({
  selector: 'pp-crypto-market',
  imports: [CommonModule, IconModule, ShortNumberPipe, TableComponent, ToCurrencyModule],
  templateUrl: './crypto-market.component.html',
  styleUrl: './crypto-market.component.scss',
})
export class CryptoMarketComponent {
  protected readonly changeType = ChangeType;
  readonly cryptoMarket$ = input<Observable<GetPaginationRes<CryptoMarketRate>>>();
  readonly cryptoMarketFilter$ = input<
    Observable<{
      sort: string;
    }>
  >();
  readonly columns = input<
    {
      i18nKey: string;
      sortable: boolean;
      name: string;
    }[]
  >();

  cryptoMarketSignal = toSignal(this.cryptoMarket$());

  onSortChange(): void {
    return;
  }
}
